var MeshType;
(function (MeshType) {
    MeshType["PLY"] = "PLY";
    MeshType["STL"] = "STL";
    MeshType["OBJ"] = "OBJ";
    MeshType["VTP"] = "VTP";
})(MeshType || (MeshType = {}));
export default MeshType;
